// extracted by mini-css-extract-plugin
export var card = "styles-module--card--bU8fb";
export var description = "styles-module--description--fdIkG";
export var imgItem = "styles-module--imgItem--wqRta";
export var sectionImages = "styles-module--sectionImages--plTRa";
export var title = "styles-module--title--9ih5J";